import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SortFunctions } from '../pipes.module/_sort.functions';
import { Sort } from '../model.module/types/sort.type';
import { TableHeader } from '../model.module/types/table-header.type';

@Component({
    selector: 'elem-new-table',
    templateUrl: './new-table.component.html',
    styleUrls: ['./new-table.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewTableComponent implements OnInit {

    @Input()
    tableHeaders: TableHeader[];

    @Input()
    set tableData(value: any) {
        this._tableData = value;

        this.updatePagination();
        this.updateVisibleTableData();
    }

    @Input()
    activatePagination = true;

    @Output()
    rowSelected = new EventEmitter<object>();

    visibleTableData: any;

    selectedRow: any;

    selectedRowIndex?: number;

    activeSort: Sort;

    pageRowLimit = 10;

    pageOffset = 0;

    numPages = 0;

    pages: number[] = [];

    _tableData: any;

    constructor() {
    }

    ngOnInit(): void {
    }

    onHeaderColumnClick(tableHeader: any) {
        if (this.activeSort && this.activeSort.cellName === tableHeader.id) {
            this.activeSort.asc = !this.activeSort.asc;
        } else {
            this.activeSort = {
                cellName: tableHeader.id,
                sortType: tableHeader.sortType,
                asc: true
            }
        }

        this.updateVisibleTableData();
    }

    onTableRowClick(line: any, i: number) {
        this.selectedRow = line;
        this.selectedRowIndex = i;

        this.rowSelected.emit(line);
    }

    onNextPageClick() {
        if (this.pageOffset === this.numPages - 1) {
            return;
        }

        this.pageOffset++;

        this.notifyPaginationChanged();
    }

    onPrevPageClick() {
        if (this.pageOffset === 0) {
            return;
        }

        this.pageOffset--;

        this.notifyPaginationChanged();
    }

    onPageNumberClick(index: number) {
        this.pageOffset = index;

        this.notifyPaginationChanged();
    }

    getActiveSortCssClass(tableHeader: any) {
        if (!this.activeSort) {
            return null;
        }

        if (this.activeSort.cellName !== tableHeader.id) {
            return null;
        }

        return {
            "elem-table__col-header--sorted-asc": this.activeSort.asc,
            "elem-table__col-header--sorted-desc": !this.activeSort.asc
        }
    }

    private updateVisibleTableData(): void {
        if (!this._tableData || !this._tableData.length) {
            return;
        }

        const processedTableData = this._tableData;

        if (this.activeSort) {
            SortFunctions.sortArray(
                this.activeSort.sortType,
                processedTableData,
                this.activeSort.cellName,
                this.activeSort.asc
            );
        }

        const segmentStart = (this.pageOffset) * this.pageRowLimit;
        const segmentEnd = (this.pageOffset + 1) * this.pageRowLimit;

        this.visibleTableData = processedTableData.slice(segmentStart, segmentEnd);
    }

    private updatePagination() {
        if (!this.activatePagination) {
            return;
        }

        if (!this._tableData || !this._tableData.length) {
            return;
        }

        this.numPages = Math.ceil(this._tableData.length / this.pageRowLimit);

        this.pages = [];
        for (let i = 0; i < this.numPages; i++) {
            this.pages.push(i);
        }
    }

    private notifyPaginationChanged() {
        this.selectedRow = undefined;
        this.selectedRowIndex = undefined;

        this.updateVisibleTableData();
    }

}
